import { render } from "./EventEdit.vue?vue&type=template&id=eb0c927c&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=js"
export * from "./EventEdit.vue?vue&type=script&lang=js"

import "./EventEdit.vue?vue&type=style&index=0&id=eb0c927c&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0c927c"]])

export default __exports__